<template>
    <div class="form-group form-inline mt-1">
        <input
        type="checkbox"
        class="form-check-input"
        id="showTooltip"
        name="showTooltip"
        v-model="showTooltip"
        @click="changeShowTooltip($event)"
        />
        <label for="showTooltip">Tooltip &nbsp;</label>
    </div>                   
</template>
<script>
import ModalLink from "../ModalLink.vue";

export default {
  name: "ShowTooltip",
  mixins: [],
  //components: {ModalLink},
  components: {},
  data() {
    return {
        showTooltip: true,
    };
  },
  props: {
    inputShowTooltip: {
        type: Boolean,
        default: true
    },    
    contentList: {
      type: Array,
      default: function() {
        return [];
      }
    },    
  },
  computed: {
  },
  mounted() {},
  created() {},
  methods: {
    changeShowTooltip: function(event) {
        this.showTooltip = event.target.checked;
        this.$parent.$emit("set-show-tooltip", this.showTooltip);
    },
  },
  watch: {
    inputShowTooltip: function(){
        this.showTooltip = this.inputShowTooltip;
    },    
  }
};
</script>
